"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditableItem = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_intl_1 = require("react-intl");
var styles_1 = require("./styles");
var Icon_1 = __importDefault(require("../Icon/Icon"));
var Typography_1 = __importDefault(require("../Typography"));
var Item_1 = require("./Item");
var formatValueToString = function (value, intl) {
    if (value instanceof Date) {
        return intl.formatDate(value, { month: 'numeric', year: 'numeric' });
    }
    if (typeof value === 'number' || typeof value === 'string') {
        return value.toString();
    }
    return '';
};
var EditableItem = function (_a) {
    var label = _a.label, value = _a.value, isEditing = _a.isEditing, onSubmit = _a.onSubmit, onBlur = _a.onBlur, onCancel = _a.onCancel, onPenClick = _a.onPenClick, maxLength = _a.maxLength, rest = __rest(_a, ["label", "value", "isEditing", "onSubmit", "onBlur", "onCancel", "onPenClick", "maxLength"]);
    var intl = (0, react_intl_1.useIntl)();
    var ref = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(function () {
        var _a;
        if (isEditing && ref.current) {
            ref.current.textContent = formatValueToString(value, intl);
            ref.current.focus();
            var range = document.createRange();
            var sel = window.getSelection();
            if (ref.current.lastChild) {
                range.setStart(ref.current.lastChild, ((_a = ref.current.textContent) === null || _a === void 0 ? void 0 : _a.length) || 0);
                range.collapse(true);
                sel === null || sel === void 0 ? void 0 : sel.removeAllRanges();
                sel === null || sel === void 0 ? void 0 : sel.addRange(range);
            }
        }
    }, [isEditing, value, intl]);
    var handleKeyDown = function (e) {
        var _a, _b, _c;
        if (e.key === 'Enter') {
            e.preventDefault();
            onSubmit(((_a = ref.current) === null || _a === void 0 ? void 0 : _a.textContent) || '');
        }
        else if (e.key === 'Escape') {
            e.preventDefault();
            onCancel === null || onCancel === void 0 ? void 0 : onCancel();
        }
        if (maxLength !== undefined && (((_c = (_b = e.currentTarget) === null || _b === void 0 ? void 0 : _b.textContent) === null || _c === void 0 ? void 0 : _c.length) || 0) >= maxLength && e.key !== 'Backspace') {
            e.preventDefault();
        }
    };
    var handleBlur = function () {
        var _a;
        var value = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.textContent;
        onBlur === null || onBlur === void 0 ? void 0 : onBlur(value || '');
    };
    return ((0, jsx_runtime_1.jsxs)(styles_1.ItemContainer, __assign({ onBlur: handleBlur, "data-testid": rest['data-testid'] }, { children: [(0, jsx_runtime_1.jsx)(styles_1.ItemLabel, __assign({ "data-testid": "".concat(rest['data-testid'], "-label") }, { children: label })), (0, jsx_runtime_1.jsx)(styles_1.ItemValue, __assign({ "data-testid": "".concat(rest['data-testid'], "-value") }, { children: isEditing ? ((0, jsx_runtime_1.jsxs)("div", __assign({ style: { display: 'flex', alignItems: 'center' } }, { children: [(0, jsx_runtime_1.jsx)(Typography_1.default.Body, { bold: true, size: "lg", ref: ref, contentEditable: true, suppressContentEditableWarning: true, onKeyDown: handleKeyDown, style: { flexGrow: 1, paddingRight: '8px', minWidth: '80px' } }), (0, jsx_runtime_1.jsx)(styles_1.BlackIcon, __assign({ onClick: onCancel }, { children: (0, jsx_runtime_1.jsx)(Icon_1.default, { name: "close" }) })), (0, jsx_runtime_1.jsx)(styles_1.RedIcon, __assign({ onClick: function () { var _a; return onSubmit(((_a = ref.current) === null || _a === void 0 ? void 0 : _a.textContent) || ''); } }, { children: (0, jsx_runtime_1.jsx)(Icon_1.default, { name: "check" }) }))] }))) : ((0, jsx_runtime_1.jsxs)("div", __assign({ style: { display: 'flex', alignItems: 'center' } }, { children: [(0, Item_1.renderValue)(value, intl), onPenClick && ((0, jsx_runtime_1.jsx)(styles_1.RedIcon, __assign({ onClick: onPenClick }, { children: (0, jsx_runtime_1.jsx)(Icon_1.default, { name: "edit-outline" }) })))] }))) }))] })));
};
exports.EditableItem = EditableItem;
